import isEqual from "fast-deep-equal/es6";
import { GeoJSONSource, LngLatBounds } from "maplibre-gl";
import { useEffect, useState } from "react";
import { emptyFeatureCollection } from "../../../util/geo";
import { useCaMap, useCaMapEvents, useSearch } from "../../state";
import { fitBounds } from "../util";

async function fetchData(client, filter, bounds, setState, source) {
  const res = await client.search([
    {
      indexName: "reference",
      params: {
        ...filter,
        insideBoundingBox: `${bounds.getNorth()},${bounds.getEast()},${bounds.getSouth()},${bounds.getWest()}`,
        facets: [],
        attributesToRetrieve: ["geometry"], // "objectID",
        hitsPerPage: 10000,
      },
    },
  ]);
  const results = res.results?.[0];
  const hits = results?.hits || [];
  const map = source.map;
  if (!hits.length) {
    const boundsResults = await client.search([
      {
        indexName: "reference",
        params: {
          ...filter,
          facets: ["geo_bounds:geometry"],
          attributesToRetrieve: ["geometry"],
          hitsPerPage: 0,
        },
      },
    ]);
    const bounds = boundsResults.results?.[0]?.facets?.geo_bounds;
    if (bounds) {
      fitBounds(map, new LngLatBounds([bounds.left, bounds.top], [bounds.right, bounds.bottom]));
    }
  }

  const geojson: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
    type: "FeatureCollection",
    features: hits.map(({ geometry, objectID }) => ({
      type: "Feature",
      properties: { id: objectID },
      geometry: { type: "Point", coordinates: geometry },
    })),
  };
  source.setData(geojson);
  map.setLayoutProperty("searchResults", "visibility", "visible");
  setState({ filter, bounds, status: "fetched" });
}

interface SearchControlState {
  filter: string;
  bounds: LngLatBounds;
  status: "fetching" | "fetched";
}
export const SearchControl = () => {
  // show filtered fields
  const map = useCaMap();
  const { client, filter, visible } = useSearch();
  const [bounds] = useCaMapEvents("moveend");
  const [state, setState] = useState<SearchControlState | null>(null);

  useEffect(() => {
    if (!map) return;
    const source = map.getSource("searchResults") as GeoJSONSource;
    if (!(visible && filter && bounds)) {
      if (state) {
        source.setData(emptyFeatureCollection);
        setState(null);
      }
      return;
    }
    if (state) {
      if (state.status === "fetching") return; // bug, should do it later
      if (isEqual(state.filter, filter) && state.bounds === bounds) return;
    }
    setState({ filter, bounds, status: "fetching" });
    fetchData(client, filter, bounds, setState, source);
  }, [map, filter, bounds, state, client, visible]);

  return null;
};
